export default __webpack_public_path__ + "static/media/img_product03.799caa41.png";